import { render, staticRenderFns } from "./SwitchDadosProvisoriosField.vue?vue&type=template&id=58012b6a&scoped=true&"
import script from "./SwitchDadosProvisoriosField.vue?vue&type=script&lang=js&"
export * from "./SwitchDadosProvisoriosField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchDadosProvisoriosField.vue?vue&type=style&index=0&id=58012b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58012b6a",
  null
  
)

export default component.exports